import React from "react";
import { HelpCircle } from "lucide-react";

/**
 * Wiederverwendbare Komponente für Statistik-Metriken
 * Reduziert Code-Duplikation und verbessert Wartbarkeit
 */
const MetricCard = ({
  icon,
  title,
  value,
  hint,
  subtitle,
  className = "",
  children,
}) => {
  return (
    <div
      className={`bg-secondary/30 backdrop-blur-sm rounded-lg pt-6 pb-10 px-2 sm:pt-6 sm:pb-10 sm:px-4 shadow-md hover:shadow-lg transition-all duration-300 relative ${className}`}
    >
      <div className="flex flex-col items-center">
        {icon && (
          <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-test/20 flex items-center justify-center mb-1 sm:mb-2">
            {icon}
          </div>
        )}

        <span className="text-test text-xs sm:text-sm font-medium text-center">
          {title}
        </span>

        {subtitle && (
          <span className="text-test/70 text-xs text-center mt-1">
            {subtitle}
          </span>
        )}

        {value && (
          <span className="text-white text-lg sm:text-2xl font-bold mt-0.5 sm:mt-2">
            {value}
          </span>
        )}

        {children}
      </div>

      {hint && (
        <span className="absolute top-2 right-2 group">
          <HelpCircle className="w-4 h-4 text-test hover:text-test/80 transition-colors" />
          <span className="absolute bottom-full right-0 mb-2 w-52 p-3 bg-primary/90 backdrop-blur-sm text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-200 pointer-events-none shadow-lg border border-primary/20 z-50">
            {hint}
          </span>
        </span>
      )}
    </div>
  );
};

export default MetricCard;
